module.exports = __webpack_public_path__ + "img/italy-transport-accidents-male.72b71bda.png";